import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StepList } from '../components/StepList';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { EntrepriseForm } from '../components/EntrepriseForm';
import { Users, FileText, Target, CheckCircle, FileSignature, HeartHandshake, Search, Briefcase, Euro, Award, ArrowDownCircle, Sparkles, Info } from 'lucide-react';
const NTC_BLOC_1 = ['Assurer une veille commerciale sur le marché, la concurrence et les opportunités', 'Identifier et segmenter les entreprises ciblées', 'Définir des cibles prioritaires et actualiser les profils clients/prospects', "Construire et mettre en œuvre un plan d'actions commerciales", 'Prospecter par téléphone, e-mail, réseau, terrain ou outils digitaux', 'Utiliser les outils numériques et le CRM pour organiser la prospection et suivre l\'activité', "Analyser les résultats obtenus à l'aide d'indicateurs de performance", 'Proposer et mettre en œuvre des actions correctives'];
const NTC_BLOC_2 = ["Représenter l'entreprise et valoriser son image", 'Analyser les besoins, attentes et contraintes du client', 'Concevoir une proposition technique et commerciale personnalisée', 'Vérifier la faisabilité de la proposition et sa rentabilité commerciale', 'Intégrer les enjeux de transition écologique dans la solution proposée', "Préparer l'argumentaire et traiter les objections", 'Présenter, argumenter et négocier la solution', 'Assurer le suivi de la solution mise en œuvre', 'Réaliser le bilan, ajuster son activité commerciale et rendre compte à la hiérarchie', 'Consolider la relation client et détecter de nouvelles opportunités commerciales'];
const ENTREPRISE_STEPS = [{
  title: 'Sourcing et définition du besoin',
  description: 'Analyse de votre poste et définition du profil idéal avec nos conseillers.',
  icon: <Search className="w-6 h-6" data-id="element-1231" data-mp="f8n55turo4o6" />
}, {
  title: 'Présélection des candidats',
  description: 'Nous vous présentons uniquement des profils qualifiés, motivés et préparés.',
  icon: <CheckCircle className="w-6 h-6" data-id="element-1232" data-mp="6cfl6hj6ojzp" />
}, {
  title: 'Aide aux démarches administratives',
  description: "Accompagnement dans la rédaction et la signature du contrat d'apprentissage (CERFA).",
  icon: <FileSignature className="w-6 h-6" data-id="element-1233" data-mp="tzw0mjlcok98" />
}, {
  title: 'Suivi personnalisé',
  description: "Points réguliers avec le tuteur en entreprise tout au long du contrat pour garantir le succès de l'alternance.",
  icon: <HeartHandshake className="w-6 h-6" data-id="element-1234" data-mp="kaw0uxz0xktz" />
}];
export function Entreprises() {
  const scrollToForm = () => {
    document.getElementById('formulaire-recrutement')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="flex flex-col w-full" data-id="element-1235" data-mp="1cx71g8mmrlqs">
      <PageHeader title="Espace Entreprises" subtitle="Recrutez vos futurs collaborateurs et dynamisez vos équipes grâce à l'alternance avec Zillenium." data-id="element-1236" data-mp="1k9wjrfhrabd7" />

      {/* Top Jump Button */}
      <div className="bg-primary-dark text-white pb-12 pt-4 text-center -mt-1" data-id="element-1237" data-mp="1u8cbnkolxonr">
        <Button onClick={scrollToForm} className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 rounded-full shadow-lg hover:scale-105 transition-transform" data-id="element-1238" data-mp="1y9pfjp853hs1">
          Confier un recrutement <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1239" data-mp="2873jipcvme3g" />
        </Button>
      </div>

      {/* Pourquoi recruter */}
      <section className="py-24 bg-white relative overflow-hidden" data-id="element-1240" data-mp="2czmynqr7phad">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-lavande rounded-full blur-[100px] opacity-30 pointer-events-none" data-id="element-1241" data-mp="2hxeyr820g9pn" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-1242" data-mp="2m0l1w6tttkrw">
          <SectionHeading title="Pourquoi recruter avec Zillenium Alternance ?" centered data-id="element-1243" data-mp="2qxtm0cyjbyvs" />
          <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-1244" data-mp="2dakwrhhdrguw">
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1245" data-mp="29aaotza12gde">
              <div className="h-2 w-full bg-brand-orange" data-id="element-1246" data-mp="2n1p8m8brelli" />
              <CardContent className="p-8 text-center" data-id="element-1247" data-mp="2n3a3y05we8kf">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1248" data-mp="2i3e2a7koat81">
                  <Target className="w-10 h-10 text-brand-orange animate-soft-bounce" data-id="element-1249" data-mp="1qboncjalmn8y" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1250" data-mp="24b7v3azhzwkq">
                  Des profils ciblés
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1251" data-mp="1zdxwb4q7y8k8">
                  Des candidats préparés aux réalités du terrain et formés aux
                  techniques commerciales actuelles.
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1252" data-mp="wih9brj437kj">
              <div className="h-2 w-full bg-primary" data-id="element-1253" data-mp="11jn7w5zgdp1z" />
              <CardContent className="p-8 text-center" data-id="element-1254" data-mp="njcf2xel20e6">
                <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1255" data-mp="nkx98lwzjhbi">
                  <FileText className="w-10 h-10 text-primary animate-soft-float" data-id="element-1256" data-mp="1g7rql9yia0kr" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1257" data-mp="1k81wynq7mt05">
                  Zéro tracas administratif
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1258" data-mp="1bfq7b42x79l8">
                  Nous vous guidons dans toutes les étapes de contractualisation
                  de votre alternant.
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1259" data-mp="23yngg1jeilpd">
              <div className="h-2 w-full bg-brand-orange" data-id="element-1260" data-mp="28tzld40gzum1" />
              <CardContent className="p-8 text-center" data-id="element-1261" data-mp="28uhomkljv93g">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1262" data-mp="23tu148wj5adz">
                  <Users className="w-10 h-10 text-brand-orange animate-soft-pulse" data-id="element-1263" data-mp="1utyjbl8gyh4z" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1264" data-mp="1q3i724gdx1k7">
                  Un partenaire de proximité
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1265" data-mp="1l4f0gfkrana4">
                  Un interlocuteur unique et réactif pour assurer le suivi de
                  votre apprenti en entreprise.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Missions en entreprise */}
      <section className="py-24 bg-muted" data-id="element-1266" data-mp="3is93assxcpyh">
        <div className="container max-w-6xl mx-auto" data-id="element-1267" data-mp="3ir6augfyefgg">
          <SectionHeading title="Les missions en entreprise" subtitle="Quelles responsabilités confier à nos alternants pour les faire monter en compétences ?" centered data-id="element-1268" data-mp="3msrx2sedo63b" />
          <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-1269" data-mp="l1sckli14v5">
            <Card className="border-none shadow-lg bg-white hover:shadow-xl transition-shadow" data-id="element-1270" data-mp="2z3ql4v6c6cta">
              <CardContent className="p-8" data-id="element-1271" data-mp="342tehicyeulf">
                <div className="flex items-center gap-4 mb-6" data-id="element-1272" data-mp="343v20mb5p9k1">
                  <div className="w-12 h-12 bg-lavande rounded-xl flex items-center justify-center" data-id="element-1273" data-mp="3926c8y5d5m2s">
                    <Briefcase className="w-6 h-6 text-primary-dark" data-id="element-1274" data-mp="3dsczouo530jg" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark" data-id="element-1275" data-mp="2gd8xv649w9fb">
                    Missions BTS NDRC
                  </h3>
                </div>
                <ul className="space-y-4 text-slate-600" data-id="element-1276" data-mp="2la91ladnh039">
                  <li className="flex items-start gap-3" data-id="element-1277" data-mp="1eq18endb9rc5">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1278" data-mp="19pwpyrsuemja" />
                    <span data-id="element-1279" data-mp="19s9g3s8r837f">
                      <strong data-id="element-1280" data-mp="1nq7gtuu5k14g">Prospection et développement :</strong> Recherche
                      de nouveaux clients, qualification de fichiers, prise de
                      rendez-vous.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1281" data-mp="1xmat3tipxg54">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1282" data-mp="1spanfjps6fej" />
                    <span data-id="element-1283" data-mp="26fxo3hf3qfd9">
                      <strong data-id="element-1284" data-mp="26f4bhztgovn7">Négociation et vente :</strong> Conduite
                      d'entretiens commerciaux, élaboration de propositions,
                      conclusion de ventes.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1285" data-mp="2gc91ybucbd9t">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1286" data-mp="2bgbl84f604wi" />
                    <span data-id="element-1287" data-mp="2v0skfmgaz8hn">
                      <strong data-id="element-1288" data-mp="2v1ljs2cxmvpr">Relation client digitale :</strong> Animation de
                      réseaux sociaux, gestion de l'e-réputation, e-mailing.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1289" data-mp="2l2crrf1mnr61">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1290" data-mp="2q1fxl1pfm1f2" />
                    <span data-id="element-1291" data-mp="2caucd6ci9fe0">
                      <strong data-id="element-1292" data-mp="2c9j9d8qvwbny">Fidélisation :</strong> Suivi client, gestion des
                      réclamations, ventes additionnelles.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white hover:shadow-xl transition-shadow" data-id="element-1293" data-mp="22ajzxnyaobzw">
              <CardContent className="p-8" data-id="element-1294" data-mp="2794zrm9mwtnt">
                <div className="flex items-center gap-4 mb-6" data-id="element-1295" data-mp="1tcrjgggu6yax">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center" data-id="element-1296" data-mp="1xdabobmn66dn">
                    <Briefcase className="w-6 h-6 text-primary" data-id="element-1297" data-mp="tz2maagsp45h" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark" data-id="element-1298" data-mp="yxvzs2w30v5n">
                    Missions TP Conseiller de Vente
                  </h3>
                </div>
                <ul className="space-y-4 text-slate-600" data-id="element-1299" data-mp="l07ckoejlbxf">
                  <li className="flex items-start gap-3" data-id="element-1300" data-mp="p0ree5a293pw">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1301" data-mp="1cpangn0xpkj1" />
                    <span data-id="element-1302" data-mp="1crn0qmvqz6pr">
                      <strong data-id="element-1303" data-mp="1howxknlguknm">Accueil et conseil :</strong> Prise en charge du
                      client, découverte des besoins, argumentation adaptée.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1304" data-mp="17y27f853n0ww">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1305" data-mp="17whe1luito0m" />
                    <span data-id="element-1306" data-mp="1vmv97l8ek2zf">
                      <strong data-id="element-1307" data-mp="20ev3oy5pe3om">Vente et encaissement :</strong> Concrétisation de
                      la vente, proposition de services annexes, gestion de la
                      caisse.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1308" data-mp="3g6yxgoov4570">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1309" data-mp="3g4cqor9sptpu" />
                    <span data-id="element-1310" data-mp="3ux684i8mojx5">
                      <strong data-id="element-1311" data-mp="3pwa7cdjkpdvy">Merchandising :</strong> Mise en rayon, maintien
                      de l'attractivité du point de vente, gestion des vitrines.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1312" data-mp="2x7uu9wk055n9">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1313" data-mp="2x9fp7na8aqln" />
                    <span data-id="element-1314" data-mp="3c66q60zjwadd">
                      <strong data-id="element-1315" data-mp="3c2969d55fesf">Gestion des stocks :</strong> Réception des
                      marchandises, inventaires, suivi des ruptures.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            {/* Missions TP Négociateur Technico-Commercial */}
            <Card className="md:col-span-2 border-none shadow-2xl ring-2 ring-brand-orange bg-white overflow-hidden" data-id="element-1316" data-mp="tiqd44knaitn">
              <div className="h-2 w-full bg-brand-orange" data-id="element-1317" data-mp="ygrwyrpwam66" />
              <CardContent className="p-8 md:p-10" data-id="element-1318" data-mp="yje5ouoiv7pz">
                <div className="flex flex-wrap items-center gap-4 mb-3" data-id="element-1319" data-mp="13hz5iszv3pdw">
                  <div className="w-12 h-12 bg-brand-orange/10 rounded-xl flex items-center justify-center" data-id="element-1320" data-mp="18gaez2m8vxvl">
                    <Briefcase className="w-6 h-6 text-brand-orange" data-id="element-1321" data-mp="asry14ifjpgi" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark" data-id="element-1322" data-mp="fqa8izc3icqm">
                    Missions TP Négociateur Technico-Commercial
                  </h3>
                  <span className="inline-flex items-center gap-1.5 bg-brand-orange text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-1323" data-mp="pgmpkhkpbns0">
                    <Sparkles className="w-3.5 h-3.5" data-id="element-1324" data-mp="3o6mx8369yy8i" />
                    Nouveauté
                  </span>
                </div>
                <p className="text-slate-600 leading-relaxed mb-8" data-id="element-1325" data-mp="2aavdnq7u5tyi">
                  Missions pouvant être confiées à l'apprenant en entreprise, en
                  cohérence avec les compétences visées par le titre
                  professionnel (RNCP39063).
                </p>

                <div className="grid md:grid-cols-2 gap-8" data-id="element-1326" data-mp="21c06aat22dtm">
                  <div data-id="element-1327" data-mp="1waas4majdk1b">
                    <div className="flex items-center gap-3 bg-lavande rounded-xl px-4 py-3 mb-5" data-id="element-1328" data-mp="1wd6qgbqaqaqa">
                      <Target className="w-5 h-5 text-primary shrink-0" data-id="element-1329" data-mp="1re3udgsaneug" />
                      <div data-id="element-1330" data-mp="1mkhj9t1s3j0r">
                        <span className="block text-xs font-bold uppercase tracking-wider text-primary" data-id="element-1331" data-mp="1mj6fvuc8wda6">
                          Bloc 1
                        </span>
                        <span className="font-bold text-primary-dark leading-snug" data-id="element-1332" data-mp="1dlw4m8zfgo59">
                          Élaborer une stratégie de prospection et la mettre en
                          œuvre
                        </span>
                      </div>
                    </div>
                    <ul className="space-y-3 text-slate-600" data-id="element-1333" data-mp="33oejpttw49nl">
                      {NTC_BLOC_1.map(mission => <li key={mission} className="flex items-start gap-3" data-id="element-1334" data-mp="38mg1mbfky2xh">
                          <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1335" data-mp="2tzmsjnwnltdq" />
                          <span data-id="element-1336" data-mp="2yx67yr538c79">{mission}</span>
                        </li>)}
                    </ul>
                  </div>

                  <div data-id="element-1337" data-mp="2l09hiqsvswqw">
                    <div className="flex items-center gap-3 bg-lavande rounded-xl px-4 py-3 mb-5" data-id="element-1338" data-mp="2px9lmw667pfd">
                      <HeartHandshake className="w-5 h-5 text-primary shrink-0" data-id="element-1339" data-mp="2b00kxbuz99az" />
                      <div data-id="element-1340" data-mp="2b2d8c4ji8bvf">
                        <span className="block text-xs font-bold uppercase tracking-wider text-primary" data-id="element-1341" data-mp="2fyk454i6s6zn">
                          Bloc 2
                        </span>
                        <span className="font-bold text-primary-dark leading-snug" data-id="element-1342" data-mp="96t4u07jino1">
                          Négocier une solution technique et commerciale et
                          consolider l'expérience client
                        </span>
                      </div>
                    </div>
                    <ul className="space-y-3 text-slate-600" data-id="element-1343" data-mp="1tottpt0yjke8">
                      {NTC_BLOC_2.map(mission => <li key={mission} className="flex items-start gap-3" data-id="element-1344" data-mp="23p4afnm7b9y5">
                          <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1345" data-mp="23n1aaarc40fp" />
                          <span data-id="element-1346" data-mp="2hibyj5b2pnb3">{mission}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>

                <div className="mt-8 flex items-start gap-3 bg-lavande/50 rounded-2xl p-5" data-id="element-1347" data-mp="2rd3vq80qu85c">
                  <Info className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1348" data-mp="2mgnc9r4hohyl" />
                  <p className="text-sm text-primary-dark leading-relaxed" data-id="element-1349" data-mp="wzw2gksf24lt">
                    Exemples de missions à adapter selon l'entreprise d'accueil
                    et le poste occupé.{' '}
                    <strong data-id="element-1350" data-mp="2s4c53c2bb72w">Conforme au référentiel RNCP39063.</strong>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="mt-12 text-center" data-id="element-1351" data-mp="3148ph1ho5js5">
            <Button onClick={scrollToForm} variant="outline" className="border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white text-lg px-8 py-6 rounded-full" data-id="element-1352" data-mp="313h3midvj0f2">
              Proposer une mission <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1353" data-mp="3g19gt3vy7cq3" />
            </Button>
          </div>
        </div>
      </section>

      {/* Aides et Salaires (Vendre du rêve) */}
      <section className="py-24 bg-white relative overflow-hidden" data-id="element-1354" data-mp="3kuccbhkacw8x">
        <div className="container max-w-6xl mx-auto" data-id="element-1355" data-mp="3osjk3mwrun7z">
          <SectionHeading title="Un recrutement très avantageux" subtitle="Profitez d'aides exceptionnelles de l'État pour l'embauche de nos alternants." centered data-id="element-1356" data-mp="3tt65exyer4hq" />

          <div className="grid md:grid-cols-3 gap-6 mt-16" data-id="element-1357" data-mp="cr31hmo2plb3">
            <Card className="bg-gradient-to-br from-primary to-primary-dark text-white border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1358" data-mp="cogtxn16n5sv">
              <CardContent className="p-8 text-center" data-id="element-1359" data-mp="2t5d8z67roih">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1360" data-mp="3uw6cfo0q0rjf">
                  <Euro className="w-8 h-8 text-white" data-id="element-1361" data-mp="vhkp5cu1tqpl" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1362" data-mp="qhybj2ab68g9">
                  5 000 €*
                </h3>
                <p className="text-lg font-medium text-lavande mb-4" data-id="element-1363" data-mp="lqq5mg86t57u">par an</p>
                <p className="text-white/90" data-id="element-1364" data-mp="hpmqxx1vlf87">
                  Aide pour l'embauche d'un{' '}
                  <strong data-id="element-1365" data-mp="1e7ixlu1rdltr">TP Conseiller de Vente</strong> (Niveau 4)
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-brand-orange to-[#d6751f] text-white border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1366" data-mp="19frgea4hssga">
              <CardContent className="p-8 text-center" data-id="element-1367" data-mp="1xvkw0pko5gt8">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1368" data-mp="1xx4aqbqofjsw">
                  <Euro className="w-8 h-8 text-white" data-id="element-1369" data-mp="1j4kd1qmaq4iu" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1370" data-mp="1o69p99l98o8i">
                  4 500 €*
                </h3>
                <p className="text-lg font-medium text-white/80 mb-4" data-id="element-1371" data-mp="2bt9fpu302hwp">par an</p>
                <p className="text-white/90" data-id="element-1372" data-mp="2gtx8ak6vn6t1">
                  Aide pour l'embauche d'un <strong data-id="element-1373" data-mp="21w4rzptiaeds">BTS NDRC</strong> (Niveau 5)
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-lavande to-[#d4c1f9] text-primary-dark border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1374" data-mp="26uofhunqzy89">
              <CardContent className="p-8 text-center" data-id="element-1375" data-mp="vhm1n7d19mrs">
                <div className="w-16 h-16 bg-primary-dark/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1376" data-mp="vezsj3ahuz7g">
                  <Euro className="w-8 h-8 text-primary-dark" data-id="element-1377" data-mp="34q0ts406v8sa" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1378" data-mp="34s4t08n57jm8">
                  6 000 €*
                </h3>
                <p className="text-lg font-medium text-primary-dark/70 mb-4" data-id="element-1379" data-mp="3eneyj6cr294r">
                  par an
                </p>
                <p className="text-primary-dark/90" data-id="element-1380" data-mp="2qzf7047m6ep4">
                  Aide maximale pour l'embauche d'un apprenti{' '}
                  <strong data-id="element-1381" data-mp="2m0u8qabxa53b">PSH</strong> (Handicap)
                </p>
              </CardContent>
            </Card>
          </div>

          <p className="text-sm text-muted-foreground mt-6 text-center max-w-3xl mx-auto" data-id="element-1382" data-mp="2zsil8eq32vkt">
            * Montants applicables aux entreprises de moins de 250 salariés.
            Pour les entreprises de 250 salariés et plus, l'aide est recalculée
            selon le niveau de qualification préparé :{' '}
            <button type="button" onClick={scrollToForm} className="text-brand-orange font-semibold underline underline-offset-2 hover:text-[#E67E22] transition-colors" data-id="element-1383" data-mp="xalpkd2a1ar6">
              contactez-nous pour en savoir plus
            </button>
            .
          </p>

          {/* Table des salaires */}
          <div className="mt-20" data-id="element-1384" data-mp="1285a1upkijrk">
            <h3 className="text-2xl font-extrabold font-heading text-primary-dark mb-8 text-center" data-id="element-1385" data-mp="1gykxzh9dc5tf">
              Grille des salaires des alternants
            </h3>
            <div className="overflow-x-auto rounded-2xl shadow-xl border border-slate-100" data-id="element-1386" data-mp="1bz8en6hphgvl">
              <table className="w-full text-left border-collapse bg-white min-w-[800px]" data-id="element-1387" data-mp="1pyrbh352h5sl">
                <thead data-id="element-1388" data-mp="1l1hkhj214m2n">
                  <tr className="bg-primary/5 text-primary-dark" data-id="element-1389" data-mp="1ky3iibxa2evq">
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1390" data-mp="3rrff3dlmhv8w">
                      Âge de l'alternant
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1391" data-mp="3mtxhgjd232g7">
                      1ère année
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1392" data-mp="278v55v79du0g">
                      2ème année
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1393" data-mp="1tgoz51xtl3eq">
                      3ème année
                    </th>
                  </tr>
                </thead>
                <tbody className="text-slate-600" data-id="element-1394" data-mp="1jhzlxmgvc74t">
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1395" data-mp="1oi4035ub0prv">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1396" data-mp="1aicfund72d5f">
                      Moins de 18 ans
                    </td>
                    <td className="p-4" data-id="element-1397" data-mp="1ej65pma7620y">
                      27% du Smic
                      <br data-id="element-1398" data-mp="34wn52wxpb9bq" />
                      <span className="font-bold text-primary text-lg" data-id="element-1399" data-mp="34xf0o7rat720">
                        504,10 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1400" data-mp="lpi09rxlhnpa">
                      39% du Smic
                      <br data-id="element-1401" data-mp="lqt0xivqufc6" />
                      <span className="font-bold text-primary text-lg" data-id="element-1402" data-mp="gqev87hm7hhb">
                        728,14 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1403" data-mp="cpd2m9i7e3ob">
                      55% du Smic
                      <br data-id="element-1404" data-mp="7qs4qgqfbw31" />
                      <span className="font-bold text-primary text-lg" data-id="element-1405" data-mp="7rl2is7enb91">
                        1 026,86 €
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1406" data-mp="10fp7fbi5jkao">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1407" data-mp="vmeac2356hvy">
                      18 à 20 ans
                    </td>
                    <td className="p-4" data-id="element-1408" data-mp="qmi5y1qj8ofv">
                      43% du Smic
                      <br data-id="element-1409" data-mp="1o5jltxi4dgx1" />
                      <span className="font-bold text-primary text-lg" data-id="element-1410" data-mp="1o5tczoewhu4b">
                        802,82 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1411" data-mp="1qpq0p089ursd">
                      51% du Smic
                      <br data-id="element-1412" data-mp="1vmzmm5wgclbg" />
                      <span className="font-bold text-primary text-lg" data-id="element-1413" data-mp="1voaqe5pwdt2k">
                        952,18 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1414" data-mp="24nxuiza0hczb">
                      67% du Smic
                      <br data-id="element-1415" data-mp="24lut7j3erxfa" />
                      <span className="font-bold text-primary text-lg" data-id="element-1416" data-mp="29nsjuye51ui9">
                        1 250,90 €
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1417" data-mp="2jd3nw6m648za">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1418" data-mp="2oc6uvwlpkp9w">
                      21 à 25 ans*
                    </td>
                    <td className="p-4" data-id="element-1419" data-mp="2sejpppyx32rw">
                      53% du Smic
                      <br data-id="element-1420" data-mp="2xclij2m5aggk" />
                      <span className="font-bold text-primary text-lg" data-id="element-1421" data-mp="2xdwmb2flbo7o">
                        989,52 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1422" data-mp="2foj294w943ik">
                      61% du Smic
                      <br data-id="element-1423" data-mp="2foaqjgbv748y" />
                      <span className="font-bold text-primary text-lg" data-id="element-1424" data-mp="2tfxvs5nsbn3v">
                        1 138,88 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1425" data-mp="2ohea86d3sdc1">
                      78% du Smic
                      <br data-id="element-1426" data-mp="20sbho3gxl02r" />
                      <span className="font-bold text-primary text-lg" data-id="element-1427" data-mp="20rk03wk652vh">
                        1 456,28 €
                      </span>
                    </td>
                  </tr>
                  <tr className="hover:bg-slate-50 transition-colors" data-id="element-1428" data-mp="2aq95ipuvouuu">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1429" data-mp="25pts5yaljncv">
                      26 ans et plus*
                    </td>
                    <td className="p-4" data-id="element-1430" data-mp="3m31wvzjrbhad">
                      100% du Smic
                      <br data-id="element-1431" data-mp="3h4gupuky2nja" />
                      <span className="font-bold text-primary text-lg" data-id="element-1432" data-mp="3h5a473bafr54">
                        1 867,02 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1433" data-mp="17x3yoqa24ot0">
                      100% du Smic
                      <br data-id="element-1434" data-mp="txce26p1ca61" />
                      <span className="font-bold text-primary text-lg" data-id="element-1435" data-mp="txufriugvglc">
                        1 867,02 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1436" data-mp="1mlqd8prv1cj6">
                      100% du Smic
                      <br data-id="element-1437" data-mp="1mmjkrsyn862d" />
                      <span className="font-bold text-primary text-lg" data-id="element-1438" data-mp="1qnbv6pj94h08">
                        1 867,02 €
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm text-muted-foreground mt-4 text-center" data-id="element-1439" data-mp="1htqjjf2dvfv1">
              * Ou salaire minimum conventionnel (SMC) s'il est plus favorable.
              Les montants sont donnés à titre indicatif sur la base du SMIC en
              vigueur.
            </p>
          </div>

          <div className="mt-16 text-center" data-id="element-1440" data-mp="2k69rlm9x8vfv">
            <Button onClick={scrollToForm} className="bg-primary hover:bg-primary-dark text-white text-lg px-8 py-6 rounded-full shadow-lg hover:scale-105 transition-transform" data-id="element-1441" data-mp="2k4yozps7ptqc">
              Estimer mon besoin de recrutement{' '}
              <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1442" data-mp="259iop311h1li" />
            </Button>
          </div>
        </div>
      </section>

      {/* Profils formés & Accompagnement */}
      <section className="py-24 bg-muted" data-id="element-1443" data-mp="1whgrddm9o1fg">
        <div className="container max-w-6xl mx-auto" data-id="element-1444" data-mp="1wgfdl1dv90u1">
          <div className="max-w-3xl mx-auto" data-id="element-1445" data-mp="1rhugvbxtozac">
            {/* Accompagnement */}
            <div data-id="element-1446" data-mp="1mjsxepwhixyc">
              <SectionHeading title="Notre accompagnement" className="mb-12" data-id="element-1447" data-mp="1mkc5lewc27z6" />
              <StepList steps={ENTREPRISE_STEPS} data-id="element-1448" data-mp="1hk7xac5kwjk1" />

              {/* Engagement Maître d'Apprentissage */}
              <div className="mt-12 bg-lavande/20 p-8 rounded-3xl border border-lavande/50 flex gap-6 items-start group hover:-translate-y-1 transition-transform" data-id="element-1449" data-mp="1dicnskdhuzv6">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1450" data-mp="3p8kfb6ud9ejz">
                  <Award className="w-8 h-8 text-primary-dark animate-soft-bounce" data-id="element-1451" data-mp="22jr97bkg4h0" />
                </div>
                <div data-id="element-1452" data-mp="6za6jsfjqw1d">
                  <h4 className="font-extrabold font-heading text-xl text-primary-dark mb-3" data-id="element-1453" data-mp="6ztmj3lmzacr">
                    L'engagement Maître d'Apprentissage
                  </h4>
                  <p className="text-primary-dark/80 leading-relaxed font-medium" data-id="element-1454" data-mp="3ai3g7u57f0q9">
                    En recrutant un alternant, vous vous engagez à désigner un
                    maître d'apprentissage chargé de l'accompagner, de lui
                    transmettre son savoir-faire et de suivre sa progression au
                    quotidien. Tout au long de la formation, des points
                    réguliers sont organisés entre l'entreprise, l'alternant et
                    notre équipe pédagogique. Chez Zillenium, on vous accompagne
                    pour de vrai.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA / Formulaire */}
      <section id="formulaire-recrutement" className="py-24 bg-primary-dark text-white relative overflow-hidden scroll-mt-16" data-id="element-1455" data-mp="1u1tnh31b7csg">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary rounded-full blur-[120px] opacity-40 pointer-events-none" data-id="element-1456" data-mp="241c69g5hgsix" />
        <div className="container max-w-4xl mx-auto text-center relative z-10" data-id="element-1457" data-mp="2cufoe1r2ptjw">
          <h2 className="text-4xl md:text-5xl font-extrabold font-heading mb-8" data-id="element-1458" data-mp="28t2khx7jk0fm">
            Confiez-nous votre recrutement
          </h2>
          <p className="text-xl md:text-2xl text-lavande mb-12 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-1459" data-mp="2mtwvmnlz4fhz">
            "Vous cherchez à renforcer vos équipes avec un alternant motivé ?
            Remplissez ce formulaire pour nous faire part de votre besoin."
          </p>
          <div className="mt-8 text-primary-dark" data-id="element-1460" data-mp="36f6ukmnnl8br">
            <EntrepriseForm data-id="element-1461" data-mp="36dvqsmu7k0kn" />
          </div>
          <div className="mt-12 pt-8 border-t border-white/10" data-id="element-1462" data-mp="2rhmqrj2htj76">
            <Link to="/candidater" className="text-lg text-lavande hover:text-white transition-colors underline underline-offset-4" data-id="element-1463" data-mp="2rjh348zp82zn">
              Vous cherchez une formation ? Candidater
            </Link>
          </div>
        </div>
      </section>
    </div>;
}